export default __webpack_public_path__ + "static/media/Firmware-pana.bd72dfb9.png";